import { Component, Input, OnInit } from '@angular/core';
import { Constant } from 'src/app/constant/constant';

@Component({
  selector: 'calsoft-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent  implements OnInit{

  @Input() value: any;
  cid: string;

  ngOnInit(): void {

    let values =localStorage.getItem(Constant.enterPriseKey);

    if(values!=null){

      this.cid="&cid="+values
    }
    

  }

}
